import React, { Component } from 'react';

import { BrowserRouter as Router, Route } from 'react-router-dom';

import Site from './components/Site';
import Layout from './templates';

import Components from './templates/components';

class App extends Component {
  render() {
    return (
      <Site>
        <Router>
          <div>
            <Route path="/components" component={Components} />
            <Layout />
          </div>
        </Router>
      </Site>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/js/App.js